
const CarwashCell = ({ carwashTypes }) => {
  return (
    <>
      {carwashTypes
        .filter(carwash => carwash.amount && Array.isArray(carwash.amount) && carwash.amount.length > 0) // Filter out types with no data
        .map((carwash, idx) => (
          <div key={idx}>
            <strong>{carwash.nameEn}:</strong>
            {carwash.amount.map((item, index) => (
              <p key={index}>{`Date: ${item.date}, Quantity: ${item.quantity}`}</p>
            ))}
          </div>
        ))}
    </>
  );
};

export default CarwashCell; 